import React from 'react';
import { Box, Rating, Typography } from '@mui/material';

interface StarsProps {
  value: {
    name: string;
    rating: number;
    customColor: {
      hex: string;
    };
  };
}

const Stars = ({ value }: StarsProps) => {
  return (
    <>
      <Box
        display={'flex'}
        gap={1.5}
        justifyContent={'center'}
        alignContent={'center'}
        alignItems={'center'}
      >
        <Rating
          name="read-only"
          readOnly
          value={value.rating ?? 4.5}
          precision={0.5}
          size={'medium'}
          // Set Color          
          sx={{
            '& .MuiRating-iconFilled': {
              color: value.customColor?.hex ?? 'primary.main',              
            },
          
          }}
        />
        <Box pt={'4px'}>
          <Typography variant={'body2'} color="primary">
            {value.rating ?? 4.5}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Stars;
